// JavaScript program to find convex hull of a set of
// points. Refer
// https://www.geeksforgeeks.org/orientation-3-ordered-points/
// https://www.geeksforgeeks.org/convex-hull-using-graham-scan/?ref=lbp
// for explanation of orientation()

// A utility function to find next to top in a stack
function nextToTop(S) {
  return S[S.length - 2];
}

// A utility function to return square of distance
// between p1 and p2
function distSq(p1, p2) {
  return (p1[0] - p2[0]) * (p1[0] - p2[0]) + (p1[1] - p2[1]) * (p1[1] - p2[1]);
}

// To find orientation of ordered triplet (p, q, r).
// The function returns following values
// 0 --> p, q and r are collinear
// 1 --> Clockwise
// 2 --> Counterclockwise
function findOrientation(p, q, r) {
  let val = (q[1] - p[1]) * (r[0] - q[0]) - (q[0] - p[0]) * (r[1] - q[1]);
  if (val === 0) return 0; // collinear
  else if (val > 0) return 1; // clock wise
  else return 2; // counterclock wise
}

/**
 * Prints convex hull of a set of n points, 点集顺序为【逆时针】
 * @param {[number, number][]} points
 * @param {number} len
 * @returns points
 */
function convexHull(points, len = 0) {
  const n = len || points.length;

  // Find the bottommost point
  let ymin = points[0][1];
  let min = 0;

  for (var i = 1; i < n; i++) {
    let y = points[i][1];

    // Pick the bottom-most or choose the left
    // most point in case of tie
    if (y < ymin || (ymin === y && points[i][0] < points[min][0])) {
      ymin = points[i][1];
      min = i;
    }
  }

  // Place the bottom-most point at first position
  [points[0], points[min]] = [points[min], points[0]];

  // Sort n-1 points with respect to the first point.
  // A point p1 comes before p2 in sorted output if p2
  // has larger polar angle (in counterclockwise
  // direction) than p1
  let p0 = points[0];
  points.sort((p1, p2) => {
    // Find orientation
    let o = findOrientation(p0, p1, p2);
    if (o === 0) {
      if (distSq(p0, p2) >= distSq(p0, p1)) return -1;
      else return 1;
    } else {
      if (o === 2) return -1;
      else return 1;
    }
  });

  // If two or more points make same angle with p0,
  // Remove all but the one that is farthest from p0
  // Remember that, in above sorting, our criteria was
  // to keep the farthest point at the end when more than
  // one points have same angle.
  let m = 1; // Initialize size of modified array
  for (let i = 1; i < n; i++) {
    // Keep removing i while angle of i and i+1 is same
    // with respect to p0
    while (i < n - 1 && findOrientation(p0, points[i], points[i + 1]) === 0) i += 1;

    points[m] = points[i];
    m += 1; // Update size of modified array
  }

  // If modified array of points has less than 3 points,
  // convex hull is not possible
  if (m < 3) return;

  // Create an empty stack and push first three points
  // to it.
  let S = [];
  S.push(points[0]);
  S.push(points[1]);
  S.push(points[2]);

  // Process remaining n-3 points
  for (let i = 3; i < m; i++) {
    // Keep removing top while the angle formed by
    // points next-to-top, top, and points[i] makes
    // a non-left turn
    while (true) {
      if (S.length < 2) break;
      if (findOrientation(nextToTop(S), S[S.length - 1], points[i]) >= 2) break;
      S.pop();
    }

    S.push(points[i]);
  }
  return S;
}
// let a = [[0, 3], [1, 1], [2, 2], [4, 4],
//             [0, 0], [1, 2], [3, 1], [3, 3]];
// console.log(convexHull(a));

export { convexHull as convexHull2 };
